import { Result } from '$lib/utils/result'

interface PayloadGetParams {
      fetch?: Function
      serverUrl: string
      collectionPath: string
      query?: any
      token?: string
      apikey?: {
            slug: string
            key: string
      }
      body?: any
      origin?: string
}

class PayloadError extends Error {
      data
      constructor(msg: string, data: unknown) {
            super(msg)
            this.data = data
            return this
      }
}

async function find({ fetch: _fetch = fetch, serverUrl, collectionPath, query = '', token = undefined, apikey = undefined, origin = undefined }: PayloadGetParams) {
      const headers = new Headers()

      if (token) {
            headers.append('Authorization', `Bearer ${token}`)
      }

      if (apikey) {
            headers.append('Authorization', `${apikey.slug} API-Key ${apikey.key}`)
      }

      if (origin) {
            headers.append('Origin', `${origin}`)
      }

      const res = await _fetch(`${serverUrl}/api${collectionPath}?${query}`, {
            method: 'get',
            credentials: 'include',
            mode: 'cors',
            headers,
      })

      const { value: json, Err: jsonErr } = await Result(() => res.json())

      if (res.status != 200) {
            throw new PayloadError('error getting collection', { data: json, Err: null })
      }

      if (jsonErr) {
            throw new PayloadError('error parsing collection data', { data: null, Err: jsonErr })
      }

      return json
}

async function create({ fetch: _fetch = fetch, serverUrl, collectionPath, query = '', token = undefined, apikey = undefined, body = {} }: PayloadGetParams) {
      const headers = new Headers()

      headers.append('content-type', 'application/json')

      if (token) {
            headers.append('Authorization', `Bearer ${token}`)
      }

      if (apikey) {
            headers.append('Authorization', `${apikey.slug} API-Key ${apikey.key}`)
      }

      const res = await _fetch(`${serverUrl}/api${collectionPath}?`, {
            method: 'post',
            credentials: 'include',
            mode: 'cors',
            headers,
            body: JSON.stringify(body),
      })

      const { value: json, Err: jsonErr } = await Result(() => res.json())

      if (res.status != 201) {
            throw new PayloadError('error creating item', { data: json, Err: null })
      }

      if (jsonErr) {
            throw new PayloadError('error parsing response', { data: null, Err: jsonErr })
      }

      return json
}

export const payload = {
      find: find,
      create: create,
}
